const DOCUMENT = 'ADMIN_ALGORITHM_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  UPDATE: DOCUMENT + 'UPDATE',
  UPDATE_SUCCESS: DOCUMENT + 'UPDATE_SUCCESS',
  CANCEL: DOCUMENT + 'CANCEL',
  TOUCH: DOCUMENT + 'TOUCH',
  TOGGLE_MODAL_PAYLOCITY_RESIDENT: DOCUMENT + 'TOGGLE_MODAL_PAYLOCITY_RESIDENT',
  CHANGE_PAYLOCITY_RESIDENT_PROPERTY: DOCUMENT + 'CHANGE_PAYLOCITY_RESIDENT_PROPERTY',
  SELECT_FOR_EDIT_PAYLOCITY_RESIDENT: DOCUMENT + 'SELECT_FOR_EDIT_PAYLOCITY_RESIDENT',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  update: data => ({
    type: actions.UPDATE,
    payload: data,
  }),

  updateSuccess: data => ({
    type: actions.UPDATE_SUCCESS,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),

  toggleModalPaylocityResident: () => ({
    type: actions.TOGGLE_MODAL_PAYLOCITY_RESIDENT,
  }),

  changePaylocityResidentProperty: data => ({
    type: actions.CHANGE_PAYLOCITY_RESIDENT_PROPERTY,
    payload: data,
  }),

  selectForEditPaylocityResident: data => ({
    type: actions.SELECT_FOR_EDIT_PAYLOCITY_RESIDENT,
    payload: data,
  }),
};

export default actions;
